var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VueMarkdown", {
    staticClass: "markdown-style aawz-markdown-render",
    attrs: {
      source: _vm.source,
      html: _vm.allowHtml,
      linkify: !_vm.noLinkify,
      postrender: _vm.postrenderComposto
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }